// extracted by mini-css-extract-plugin
module.exports = {"story":"StorySection_story__gondT","inner":"StorySection_inner__UQvxN","title":"StorySection_title__A4Kgv","text":"StorySection_text___LiKl"};